// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"IngredientGroupDropdown_ItemsWrapper__TqKmu","Slide":"IngredientGroupDropdown_Slide__mdbYM","Active":"IngredientGroupDropdown_Active__JW5G5"};